export default __webpack_public_path__ + "static/media/SapLitmos.cf5552b9.svg";